module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_005.png
// module id = 2321
// module chunks = 5